// project import
import pages from "./pages"
import dashboard from "./dashboard"
import admin from "./admin"

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, admin],
}

export default menuItems
